/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import image1 from "assets/images/intro/tech-escrow/2kv_led_converter&dc_controller.pdf";

// 특허
import chattering from "assets/images/intro/patent/chattering.png";
import umbrella from "assets/images/intro/patent/디자인 우산등.png";
import ac_chattering_swich from "assets/images/intro/patent/AC 채터링 및 잔광제거 부하보호 스위치 회로_1.png";
import ac_line from "assets/images/intro/patent/AC라인보호기_1.png";
import switch_ from "assets/images/intro/patent/조광기 스위치_1.png";
import dc_switch_ from "assets/images/intro/patent/DC 디밍 제어가 가능한 조광기 시스템.png";

// 기술임치
import tech_1 from "assets/images/intro/tech-escrow/2KV 서지보호 LED 컨버터 및 DC제어 LED디밍 컨트롤 회로-1.png";
import tech_2 from "assets/images/intro/tech-escrow/AC 채터링 및 잔광제거 부하 보호 스위치 회로_보급형_20240513170600047-1.png";

// AC 인증서
import certification_AC_1 from "assets/images/intro/certification/AC타입 인증서/AC타입 안전인증 JF11037-(18002_23001_24001)/안전인증JF11037-18002O매입형3인치5W부터6인치20W센서등포함_기본모델.png";
import certification_AC_2 from "assets/images/intro/certification/AC타입 인증서/AC타입 안전인증 JF11037-(18002_23001_24001)/안전인증JF11037-21001  8인치35W매입등안전인증서.png";
import certification_AC_3 from "assets/images/intro/certification/AC타입 인증서/AC타입 안전인증 JF11037-(18002_23001_24001)/안전인증JF11037-24001(3500K3인치4인치6인치)_ (회전확산형3인치8W).png";
import certification_AC_4 from "assets/images/intro/certification/AC타입 인증서/AC타입 안전인증 JF11037-(18002_23001_24001)/안전인증_JF11037-23001회전형 매입등 5인치 센서등.png";
import certification_AC_5 from "assets/images/intro/certification/AC타입 인증서/AC타입 전자파 _ 센서등 일반 매입등/방송통신기자재등의 적합등록 필증_좋은빛_LED 등기구(매입형)_R-R-JEb-JO15-DL176P115_20240312.png";
import certification_AC_6 from "assets/images/intro/certification/AC타입 인증서/AC타입 전자파 _ 센서등 일반 매입등/방송통신기자재등의 적합등록 필증_좋은빛_LED 등기구_R-R-JEb-JO35-DL225_최종.png";

// DC 인증서
import certification_DC_1 from "assets/images/intro/certification/DC타입 인증서/0_안전인증/안전인증서 등기구_좋은빛_JF11037-24003_240722_240722_183933.png";
import certification_DC_2 from "assets/images/intro/certification/DC타입 인증서/0_안전인증/안전인증서 컨버터_좋은빛_JF11037-24002_240717.png";
import certification_DC_3 from "assets/images/intro/certification/DC타입 인증서/0_전자파/LED 등기구(매입형) 완제품_방송통신기자재등의 적합등록 필증_좋은빛_R-R-JEb-LUS-0620-145_20240718.png";
import certification_DC_4 from "assets/images/intro/certification/DC타입 인증서/0_전자파/조명기구용컨버터(LED램프용_방송통신기자재등의 적합등록 필증_좋은빛_R-R-JEb-LUS-Samsung-LED-0520_20240715.png";

// 고효율 인증서
import certification_eff_3_1 from "assets/images/intro/certification/고효율 인증서/3인치 5W 3000_고효율기자재 인증서.png";
import certification_eff_3_2 from "assets/images/intro/certification/고효율 인증서/3인치 5W 4000_고효율기자재 인증서.png";
import certification_eff_3_3 from "assets/images/intro/certification/고효율 인증서/3인치 5W 5700 _ 고효율기자재 인증서.png";
import certification_eff_4_1 from "assets/images/intro/certification/고효율 인증서/4인치 10W 3000_고효율기자재 인증서.png";
import certification_eff_4_2 from "assets/images/intro/certification/고효율 인증서/4인치 10W 4000_고효율기자재 인증서.png";
import certification_eff_4_3 from "assets/images/intro/certification/고효율 인증서/4인치 10W 5700_고효율기자재 인증서.png";
import certification_eff_6_1 from "assets/images/intro/certification/고효율 인증서/6인치 15W 3000_고효율기자재 인증서.png";
import certification_eff_6_2 from "assets/images/intro/certification/고효율 인증서/6인치 15W 4000_고효율기자재 인증서.png";
import certification_eff_6_3 from "assets/images/intro/certification/고효율 인증서/6인치 15W 5700 _ 고효율기자재 인증서.png";

// 센서스위치 인증서
import certification_sensr_1 from "assets/images/intro/certification/센서스위치 인증서/안전인증/HF020003-24002A_MDYYe.png";
import certification_sensr_2 from "assets/images/intro/certification/센서스위치 인증서/안전인증/HF020003-24003A_XHUei.png";
import certification_sensr_3 from "assets/images/intro/certification/센서스위치 인증서/전자파/RF센서 스위치 전자파인증서_R-R-JEb-LUS-MW1000_20241016.png";

// 조광기 인증서
import certification_dim_1 from "assets/images/intro/certification/조광기 인증서/조광기 인증서.png";
import certification_dim_2 from "assets/images/intro/certification/조광기 인증서/조광기 전자파인증서.png";
import certification_dim_3 from "assets/images/intro/certification/조광기 인증서/조광기 500W 안전인증서.png";
import certification_dim_4 from "assets/images/intro/certification/조광기 인증서/조광기 500W 전자파 적합등록 필증.png";

export default [
  {
    title: "특허권",
    description:
      "특허권은 발명가에게 주어지는 발명 제품을 독점적 제조, 사용, 판매, 수입할 수 있는 권리,",
    items: [
      {
        image: chattering,
        name: "채터링 방지회로",
        desciption: "해당 설명",
        status: false, // 등록 완료
      },
      {
        image: umbrella,
        name: "우산등 디자인",
        desciption: "해당 설명",
        status: false, // 등록 완료
      },
      {
        image: ac_chattering_swich,
        name: "AC 채터링 및 잔광제거 부하보호 스위치 회로",
        desciption: "해당 설명",
        status: false,
      },
      {
        image: ac_line,
        name: "AC 라인 보호기",
        desciption: "해당 설명",
        status: false,
      },
      {
        image: switch_,
        name: "조광기 스위치",
        desciption: 11,
        status: false,
      },
      {
        image: dc_switch_,
        name: "DC 디밍 제어가 가능한 조광기 시스템",
        desciption: 11,
        status: false,
      },
    ],
  },
  {
    title: "기술임치",
    description: "개발기술에 법의 보호를 받습니다. 기술의 신뢰성을 입증할 수 있습니다",
    items: [
      {
        image: tech_1,
        name: "2KV 서지보호 LED 컨버터 및 DC제어 LED디밍 컨트롤 회로",
        desciption: 4,
      },
      {
        image: tech_2,
        name: "AC 채터링 및 잔광제거 부하 보호 스위치 회로_보급형",
        desciption: 2,
      },
    ],
  },
  {
    title: "AC타입 인증서",
    description: "",
    items: [
      {
        image: certification_AC_1,
        name: ["IC일체형 매입등 센서등", <br key="line-break" />, "(3인치5W~6인치20W)"], // JSX에서 <br />로 줄바꿈 처리
        desciption: 6,
        pro: true,
      },
      {
        image: certification_AC_2,
        name: ["1C일체형 매입등", <br key="line-break" />, "8인치 35W"], // JSX에서 <br />로 줄바꿈 처리
        desciption: 8,
        pro: true,
      },
      {
        image: certification_AC_3,
        name: ["1C일체형 매입등", <br key="line-break" />, "3500K 칼라"], // JSX에서 <br />로 줄바꿈 처리
        desciption: 3,
      },
      {
        image: certification_AC_4,
        name: ["1C일체형 회전타입 매입등, 5인치 센서등"], // JSX에서 <br />로 줄바꿈 처리
        desciption: 6,
      },
      {
        image: certification_AC_5,
        name: ["전자파_IC일체형 매입등 센서등"], // JSX에서 <br />로 줄바꿈 처리
        desciption: 6,
      },
      {
        image: certification_AC_6,
        name: [
          "전자파 IC일체형",
          <br key="line-break" />,
          "6인치20W 8인치 35W",
          <br key="line-break" />,
          "회전형 제품",
        ], // JSX에서 <br />로 줄바꿈 처리
        desciption: 6,
      },
    ],
  },
  {
    title: "DC타입 인증서",
    description: "",
    items: [
      {
        image: certification_DC_1,
        name: "DC타입 완제품 안전인증",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_DC_2,
        name: "DC타입 컨버터 안전인증",
        desciption: 8,
        pro: true,
      },
      {
        image: certification_DC_3,
        name: "DC타입 완제품 전자파인증",
        desciption: 3,
      },
      {
        image: certification_DC_4,
        name: "DC타입 컨버터 전자파인증",
        desciption: 6,
      },
    ],
  },
  {
    title: "고효율 인증서",
    description: "",
    items: [
      {
        image: certification_eff_3_1,
        name: "3인치 5W 3000_고효율기자재",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_eff_3_2,
        name: "3인치 5W 4000_고효율기자재 인증서",
        desciption: 8,
        pro: true,
      },
      {
        image: certification_eff_3_3,
        name: "3인치 5W 5700_고효율기자재 인증서",
        desciption: 3,
      },
      {
        image: certification_eff_4_1,
        name: "4인치 10W 3000_고효율기자재 인증서",
        desciption: 6,
      },
      {
        image: certification_eff_4_2,
        name: "4인치 10W 4000_고효율기자재 인증서",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_eff_4_3,
        name: "4인치 10W 5700_고효율기자재 인증서",
        desciption: 8,
        pro: true,
      },
      {
        image: certification_eff_6_1,
        name: "6인치 15W 3000_고효율기자재 인증서",
        desciption: 3,
      },
      {
        image: certification_eff_6_2,
        name: "6인치 15W 4000_고효율기자재 인증서",
        desciption: 6,
      },
      {
        image: certification_eff_6_3,
        name: "6인치 15W 5700_고효율기자재 인증서",
        desciption: 6,
      },
    ],
  },
  {
    title: "센서스위치 인증서",
    description: "",
    items: [
      {
        image: certification_sensr_1,
        name: "센서스위치 200W 안전인증",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_sensr_2,
        name: "센서스위치 1000W 안전인증",
        desciption: 8,
        pro: true,
      },
      {
        image: certification_sensr_3,
        name: "센서스위치 전자파인증",
        desciption: 3,
      },
    ],
  },
  {
    title: "조광기 인증서",
    description: "",
    items: [
      {
        image: certification_dim_1,
        name: "조광기 180W 안전인증",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_dim_2,
        name: "조광기 전자파인증서",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_dim_3,
        name: "조광기 500W 안전인증서",
        desciption: 6,
        pro: true,
      },
      {
        image: certification_dim_4,
        name: "조광기 500W 전자파 적합등록 필증",
        desciption: 6,
        pro: true,
      },
    ],
  },
];
